import { render, staticRenderFns } from "./ApRecycleBin.vue?vue&type=template&id=619b19f2&"
import script from "./ApRecycleBin.vue?vue&type=script&lang=js&"
export * from "./ApRecycleBin.vue?vue&type=script&lang=js&"
import style0 from "./ApRecycleBin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ApRecycleBin.vue"
export default component.exports